import { Environment } from '@doc/core';

export const environment: Environment = {
  production: false,
  application: 'DMA-UI',
  // apiUrl: 'https://amm-api.fit-infotech.com',
  // apiUrl: 'http://localhost:5137',
  // apiUrl: 'https://media-devapi.aspirezone.qa',
  apiUrl: 'https://sjc-admin-api.fit-infotech.com',
  mockUrl: 'http://localhost:3000',
  instrumentationKey: 'e3952420-672a-40df-bdca-0d4967abfad8',
  sso: false,
  azureAd: {
    clientId: '01318090-ddd1-4bd3-8361-6342b40c899b',
    authority: 'https://login.microsoftonline.com/0870288e-4af8-48c9-873e-3ad9b170eb26',
    redirectUri: 'https://media-dev.aspirezone.qa',
    apiScopes: [
      'api://01318090-ddd1-4bd3-8361-6342b40c899b/user.read',
      'api://01318090-ddd1-4bd3-8361-6342b40c899b/user.write'
    ],
    graphResource: 'https://graph.microsoft.com/v1.0/me',
    graphScopes: ['User.Read']
  },
  passKey: "E2EA9C6CD809197E",
  passValue: "6BD9B374A3D5792B",
  idleTime: 5 * 60 * 1000,
logoutTime: 5 * 60 * 1000,
  ProcessDocApiLimit: 180000,
  ProcessDocApiInterval: 10000,
  resumableUpload: {
    enabled: true,
    thresholdBytes: 100 * 1024 * 1024, // 100MB
    chunkSizeBytes: 5 * 1024 * 1024, // 5MB,
    streamThroughBackend: true,
    maxRetries: 3,
    chunkUploadTimeout: 120000, // Base timeout: 120 seconds (2 minutes) 
    timeoutMultipliers: {
      slow: 10,      // 10x = 1200 seconds (20 minutes) 
      medium: 6,     // 6x = 720 seconds (12 minutes) 
      fast: 3,       // 3x = 360 seconds (6 minutes) 
      veryFast: 2    // 2x = 240 seconds (4 minutes) 
    },
    minTimeout: 60000,  // Minimum 60 seconds 
    maxTimeout: 1200000 // Maximum 20 minutes 
  },
  resumableDownload: {
    enabled: true,
    chunkSizeBytes: 5 * 1024 * 1024, // 5MB
    maxRetries: 3,
    maxConcurrentChunks: 5, // same bands as upload: slow2 / med3 / fast4 / veryFast5
    speedMeasurementInterval: 5,
    // false = no save-as picker; files auto-save to the browser's default Downloads folder.
    streamToDisk: false,
  },
  enableMultiSelect: true,
  isDepartemntShareEnable: false,
  isMultiMoveEnabled: true,
  allowedDomains: ['aspirezone.qa', 'aspire.qa', 'aspirelogistics.qa', 'aspetar.com'],
  mfaConfig: {
    isEnabled: false,
    isMobile: false,
    isByEmail: true,
    otpExpiryMinutes: 2,
    otpLength: 6,
    lockedTimeOfExceededAttempt: 10
  },
  autoIncrementDuplicateFile: true,
  allowDuplicate: true,
  userQuotaEnabled: true,
  isDepartQuotaManagement: true,
  enableUploadFolder: true,
  allowedUploadTypes: [
    'image/jpeg',
    'image/png',
    'video/mp4',
    'video/quicktime',
    'application/pdf',
    'application/zip'
  ],
  isNewSearchBar: false,
  useGlobalSearchApi: true,
  showMyfiles: false,
  showArchivedMenu: false,
  isSharePermission: false,
  isLocationAndTagManagementEnabled: true,
  isFolderHierarchyManagementEnabled: true,
  isEventsSecExpanded : false,
    isLocationSecExpanded : false,
};
